(function () {
  'use strict';
  var PROMO_API_URL = '/apps/cblistdis';
  var GIFT_INFO_KEY = '_tired_free';
  // Quantity used only to ask the API which campaign a product belongs to (see buildCampaignGroups).
  var CAMPAIGN_PROBE_QTY = 1000;
  // How long a product's campaign stays cached in sessionStorage (campaigns rarely change mid-visit).
  var CAMPAIGN_CACHE_MS = 10 * 60 * 1000;
  // Cap of one free box per box bought on that eye (see splitGroupByProduct).
  var OWN_BOXES_RULE = { buyQty: 1, getQty: 1 };
  var syncInProgress = false;
  var debounceTimer;

  /* ── 1. UX: Loader ── */
  function toggleLoading(show) {
    let loader = document.getElementById('gift-sync-loader');
    if (show) {
      if (!loader) {
        loader = document.createElement('div');
        loader.id = 'gift-sync-loader';
        loader.innerHTML = `
          <div style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(255,255,255,0.7);
          z-index:2147483647;display:flex;flex-direction:column;align-items:center;justify-content:center;backdrop-filter:blur(2px);">
            <div style="width:40px;height:40px;border:4px solid #f3f3f3;border-top:4px solid #000;border-radius:50%;animation:spin 1s linear infinite;"></div>
            <p style="margin-top:15px;font-family:sans-serif;font-weight:600;color:#111;">Checking for free gifts...</p>
          </div>
          <style>@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }</style>
        `;
        document.body.appendChild(loader);
      }
    } else if (loader) { loader.remove(); }
  }

  /* ── 2. HELPERS ── */
  function isGiftItem(item) {
    var props = item.properties || {};
    var val = props[GIFT_INFO_KEY];
    if (!val) return false;
    if (typeof val === 'object') return val.status === true;
    try {
      return JSON.parse(val).status === true;
    } catch (e) { return String(val).includes('true'); }
  }

  function getSide(item) {
    var props = item.properties || {};
    if (props['_side']) return props['_side'].toLowerCase();
    var eyeSide = (props['_Eye Side'] || props['Eye Side'] || props['Box'] || '').toLowerCase();
    if (eyeSide.indexOf('left') !== -1) return 'left';
    if (eyeSide.indexOf('right') !== -1) return 'right';
    return 'left';
  }

  /* Render the cart-page promo banner as a dynamic, selectable block — same UX as the
     product-page promo banner (image 2). One block per campaign group in the cart: shows
     the gift-split options for that group, pre-selects the split currently in the cart, and
     calls onSelect(groupIdx, choice) (which re-splits the cart) when the customer picks a
     different option. */
  function renderCartGiftBanner(groups, onSelect) {
    var banner = document.getElementById('cart-gift-banner');
    if (!banner) return;

    if (!groups || groups.length === 0) {
      banner.style.display = 'none';
      banner.innerHTML = '';
      return;
    }

    var html = '<div class="promo-header">You qualify for the following FREE promotion boxes:</div>';
    groups.forEach(function (group, gIdx) {
      var options = group.options;
      // Pre-select the option matching the split currently in the cart.
      var selectedIdx = Math.max(0, options.indexOf(group.currentChoice));

      html += '<div class="promo-body" data-group="' + gIdx + '">';
      if (groups.length > 1) {
        html += '<div class="promo-subtitle text-sm">' + escapeHtml(groupTitle(group)) + '</div>';
      }
      if (options.length > 1) {
        html += '<div class="promo-subtitle text-sm text-theme-light">Select your preference below</div>';
        html += '<div class="promo-options">';
        options.forEach(function (opt, idx) {
          html += '<label class="promo-option' + (idx === selectedIdx ? ' checked' : '') + '">' +
            '<input type="radio" name="cart-gift-sel-' + gIdx + '" value="' + idx + '"' + (idx === selectedIdx ? ' checked' : '') + '>' +
            '<span class="promo-option-text">' + giftSplitLabel(opt) + '</span>' +
          '</label>';
        });
        html += '</div>';
      } else {
        html += '<div class="promo-single-text">' + giftSplitLabel(options[0]) + '</div>';
      }
      html += '</div>';
    });

    // Scroll the banner to the top of the viewport whenever its content actually changes
    // (e.g. options appear or the split updates), to draw the customer's attention.
    var contentChanged = banner.innerHTML !== html;
    banner.style.display = 'block';
    banner.innerHTML = html;
    if (contentChanged) {
      // Defer so layout settles (esp. right after a reload) — otherwise the browser skips
      // the smooth animation and it reads as an instant jump to the top.
      setTimeout(function () {
        var bannerTop = banner.getBoundingClientRect().top + window.pageYOffset - 150;
        window.scrollTo({ top: Math.max(0, bannerTop), behavior: 'smooth' });
      }, 400);
    }

    banner.querySelectorAll('.promo-body').forEach(function (body) {
      var gIdx = parseInt(body.getAttribute('data-group'), 10);
      var group = groups[gIdx];
      body.querySelectorAll('.promo-option').forEach(function (el) {
        el.onclick = function () {
          var idx = parseInt(el.querySelector('input').value, 10);
          if (group.options[idx] === group.currentChoice) return; // already the active split
          body.querySelectorAll('.promo-option').forEach(function (x) {
            x.classList.remove('checked');
            x.querySelector('input').checked = false;
          });
          el.classList.add('checked');
          el.querySelector('input').checked = true;
          if (onSelect) onSelect(gIdx, group.options[idx]);
        };
      });
    });
  }

  /* Product titles of a campaign group, shown above its options when the cart has more than one. */
  function groupTitle(group) {
    var titles = [];
    group.entries.forEach(function (e) {
      if (titles.indexOf(e.item.product_title) === -1) titles.push(e.item.product_title);
    });
    return titles.join(', ');
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Label matching the product-page promo banner format, e.g. "2 Boxes (R) + 2 Boxes (L)". */
  function giftSplitLabel(opt) {
    var r = opt.rightGiftQty || 0;
    var l = opt.leftGiftQty || 0;
    var rLabel = r + ' Box' + (r === 1 ? '' : 'es') + ' (R)';
    var lLabel = l + ' Box' + (l === 1 ? '' : 'es') + ' (L)';
    return rLabel + ' + ' + lLabel;
  }

  /* Turn free-gift line items into normal (simple) products by removing the _tired_free
     marker. Used when the cart is no longer eligible for any free gift. */
  async function convertGiftsToSimple(gifts, shouldReload = true) {
    if (!gifts || !gifts.length) return;
    toggleLoading(true);
    for (const g of gifts) {
      const newProps = {};
      for (let k in g.properties) {
        if (k !== '_tired_free') newProps[k] = g.properties[k];
      }
      await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: g.key, quantity: g.quantity, properties: newProps })
      });
    }
    if (shouldReload) window.location.reload();
  }

  async function syncGiftsInCart(isManualAction = false) {
    if (syncInProgress) return;
    syncInProgress = true;
    try {
      let retries = 0;
      while (!(window.__giftVariantMap || window.variantMetafields) && retries < 20) {
        await new Promise(r => setTimeout(r, 100));
        retries++;
      }

      const cart = await fetch(window.Shopify.routes.root + 'cart.js').then(r => r.json());
      const items = cart.items || [];

      const paidGiftItemsToFix = items.filter(i => {
        if (!isGiftItem(i)) return false;
        const hasDiscount = i.final_price < i.original_price || i.final_price === 0 || i.price === 0 || i.total_discount > 0 || (i.discounts && i.discounts.length > 0);
        return !hasDiscount;
      });

      if (paidGiftItemsToFix.length > 0) {
        toggleLoading(true);
        for (const pItem of paidGiftItemsToFix) {
          const newProps = {};
          for (let k in pItem.properties) {
            if (k !== '_tired_free') newProps[k] = pItem.properties[k];
          }
          await fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: pItem.key,
              quantity: pItem.quantity,
              properties: newProps
            })
          });
        }
        window.location.reload();
        return;
      }

      const mainItems = items.filter(i => !isGiftItem(i));
      const giftItems = items.filter(i => {
        if (!isGiftItem(i)) return false;
        const hasDiscount = i.final_price < i.original_price || i.final_price === 0 || i.price === 0 || i.total_discount > 0 || (i.discounts && i.discounts.length > 0);
        return hasDiscount;
      });

      if (mainItems.length === 0) {
        // No main products left → the gifts are no longer free; make them simple products.
        if (giftItems.length > 0) await convertGiftsToSimple(giftItems);
        return;
      }

      // Main items that map to a free-gift variant.
      const entries = mainItems
        .filter(item => getGiftVariantId(item))
        .map(item => ({ item: item, side: getSide(item) }));

      if (entries.length === 0) {
        // No main product maps to a gift → convert any existing gifts to simple products.
        if (giftItems.length > 0) await convertGiftsToSimple(giftItems);
        return;
      }

      const currentSignature = entries
        .map(e => e.item.variant_id + ':' + e.side + ':' + e.item.quantity)
        .sort().join(',');
      if (window.__lastGiftSignature === currentSignature && !isManualAction) {
        return;
      }
      window.__lastGiftSignature = currentSignature;

      // Boxes are priced per campaign (never pooled across campaigns), then each product of a
      // campaign gets its own share and its own split options.
      const groups = (await buildCampaignGroups(entries))
        .filter(g => g.options.length > 0)
        .flatMap(splitGroupByProduct);

      // No valid free-gift split for the current quantity → hide the banner and turn any
      // existing free gifts into normal (simple) products.
      if (groups.length === 0) {
        renderCartGiftBanner([]);
        if (giftItems.length > 0) await convertGiftsToSimple(giftItems);
        return;
      }

      // Match each gift line to its campaign group via its parent (main) variant. Gifts whose
      // parent is no longer in an eligible group are orphans.
      const orphanGifts = [];
      giftItems.forEach(g => {
        const parentId = String(getGiftParentId(g));
        const group = groups.find(gr => gr.entries.some(e => String(e.item.variant_id) === parentId));
        if (group) group.gifts.push(g);
        else orphanGifts.push(g);
      });

      // A group is valid when its gifts are exactly what one of its options allocates.
      groups.forEach(gr => {
        const actual = giftAllocationKey(gr.gifts.map(g => ({ variantId: getGiftParentId(g), side: getSide(g), qty: g.quantity })));
        gr.currentChoice = gr.options.find(opt =>
          giftAllocationKey(allocateGifts(gr, opt).map(a => ({ variantId: a.item.variant_id, side: a.side, qty: a.qty }))) === actual
        ) || null;
      });

      // Cart gifts are stale, mixed between campaigns, or no longer a valid split → apply
      // the default split per group so the cart is correct, then reload (the selector
      // renders on reload).
      if (orphanGifts.length > 0 || groups.some(gr => !gr.currentChoice)) {
        toggleLoading(true);
        if (orphanGifts.length > 0) await convertGiftsToSimple(orphanGifts, false);
        await executeGiftUpdate(groups.map(gr => ({ group: gr, choice: gr.currentChoice || gr.options[0] })), true);
        return;
      }

      // Cart already holds a valid split → render the dynamic selector (same options the
      // product page shows). Picking a different option re-splits that group's gifts.
      renderCartGiftBanner(groups, async (gIdx, choice) => {
        // Lock the sync while re-splitting: removing the old gifts goes through cart/update,
        // which would otherwise start a second sync that adds its own default gifts too.
        if (syncInProgress) return;
        syncInProgress = true;
        clearTimeout(debounceTimer);
        toggleLoading(true);
        try {
          await executeGiftUpdate(groups.map((gr, i) => ({ group: gr, choice: i === gIdx ? choice : gr.currentChoice })), true);
        } catch (e) {
          console.error('[GiftSync] Error:', e);
          toggleLoading(false);
          syncInProgress = false;
        }
      });

    } catch (e) {
      console.error('[GiftSync] Error:', e);
      toggleLoading(false);
    } finally {
      setTimeout(() => { syncInProgress = false; }, 500);
    }
  }

  /* Gift variant id (numeric) configured on a main item's variant (custom.free_gift_variant_id). */
  function getGiftVariantId(item) {
    const map = window.__giftVariantMap || window.variantMetafields || {};
    let gVar = map[String(item.variant_id)] || (window.variantMetafields ? window.variantMetafields[String(item.variant_id)]?.custom_field : null);
    let gId = gVar?.custom_field || gVar;

    if (gId && typeof gId === 'object') {
      if (gId.id !== undefined) gId = gId.id;
      else if (Array.isArray(gId) && gId.length > 0) {
        gId = typeof gId[0] === 'object' ? gId[0].id : gId[0];
      }
    }

    if (typeof gId === 'string' && gId.includes('gid://')) {
      gId = gId.split('/').pop();
    }
    return gId || null;
  }

  /* Main variant id a gift line was created for (_tired_free.parent_id). */
  function getGiftParentId(item) {
    var val = (item.properties || {})[GIFT_INFO_KEY];
    try {
      var info = typeof val === 'object' ? val : JSON.parse(val);
      return info && info.parent_id != null ? info.parent_id : null;
    } catch (e) { return null; }
  }

  async function fetchPromo(entries, quantity) {
    // Dedupe: both eyes often share the same variant (eye side is a line-item property,
    // not a variant option). The product page sends unique ids to the promo API; match that.
    const variantIds = [];
    entries.forEach(e => {
      if (variantIds.indexOf(e.item.variant_id) === -1) variantIds.push(e.item.variant_id);
    });
    const apiRes = await fetch(PROMO_API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ shop: window.Shopify.shop, CID: window.__giftCustomerId || null, quantity: quantity, cartVariantIds: variantIds.map(id => ({ variantId: String(id), quantity: 1 })), type: 'tired-price' })
    }).then(r => r.json());
    return apiRes?.success ? apiRes.data : null;
  }

  /* Split the cart into one group per campaign, so boxes of different campaigns are never
     pooled together (e.g. a buy-1-get-1 product and a buy-4-get-2 product in one cart).
     Each product is first probed with a large quantity: the API answers with the rule of
     the campaign it belongs to (bestRule.id), even when the product alone is still below
     that campaign's buy threshold. Products sharing a rule are then priced together with
     their combined quantity, which gives each group its own free-box options. */
  async function buildCampaignGroups(entries) {
    const byProduct = {};
    entries.forEach(e => {
      (byProduct[e.item.product_id] = byProduct[e.item.product_id] || []).push(e);
    });

    // Probes run in parallel; a product's campaign is cached for the session (see getCampaignRuleId).
    const productIds = Object.keys(byProduct);
    const ruleIds = await Promise.all(productIds.map(productId => getCampaignRuleId(productId, byProduct[productId])));

    const entriesByRule = {};
    productIds.forEach((productId, i) => {
      if (!ruleIds[i]) return; // not in any campaign this customer qualifies for
      entriesByRule[ruleIds[i]] = (entriesByRule[ruleIds[i]] || []).concat(byProduct[productId]);
    });

    // One pricing call per campaign, also in parallel.
    return Promise.all(Object.keys(entriesByRule).map(async ruleId => {
      const groupEntries = entriesByRule[ruleId];
      let leftQty = 0, rightQty = 0;
      groupEntries.forEach(e => {
        if (e.side === 'left') leftQty += e.item.quantity;
        else if (e.side === 'right') rightQty += e.item.quantity;
      });
      const res = await fetchPromo(groupEntries, leftQty + rightQty);
      const totalGiftQty = res ? Math.floor(Number(res.getQty)) : 0;
      const rule = res ? res.bestRule : null;
      return {
        entries: groupEntries,
        rule: rule,
        totalGiftQty: totalGiftQty,
        options: totalGiftQty > 0 ? buildOptions(totalGiftQty, leftQty > 0, rightQty > 0, leftQty, rightQty, rule) : [],
        gifts: [],
        currentChoice: null
      };
    }));
  }

  /* Campaign (bestRule.id) a product belongs to for this customer, or null. Cached in
     sessionStorage for CAMPAIGN_CACHE_MS so quantity changes don't re-probe every product;
     storage can be unavailable (private mode), in which case it just probes. */
  async function getCampaignRuleId(productId, productEntries) {
    const cacheKey = 'cbGiftCampaign:' + (window.__giftCustomerId || 'guest') + ':' + productId;
    try {
      const cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
      if (cached && Date.now() - cached.t < CAMPAIGN_CACHE_MS) return cached.r;
    } catch (e) { /* no cache */ }

    const probe = await fetchPromo(productEntries, CAMPAIGN_PROBE_QTY);
    const ruleId = probe && probe.bestRule ? String(probe.bestRule.id) : null;
    try {
      sessionStorage.setItem(cacheKey, JSON.stringify({ r: ruleId, t: Date.now() }));
    } catch (e) { /* no cache */ }
    return ruleId;
  }

  /* Split a campaign group into one section per product, each with its own share of the
     campaign's free boxes and its own Right/Left options (same shape as a group, so the banner,
     allocation and gift building work on it unchanged). A single-product group keeps the
     campaign's options as they are. */
  function splitGroupByProduct(group) {
    const products = [];
    group.entries.forEach(e => {
      let p = products.find(x => x.productId === e.item.product_id);
      if (!p) {
        p = { productId: e.item.product_id, entries: [], rule: group.rule, leftQty: 0, rightQty: 0, gifts: [], currentChoice: null };
        products.push(p);
      }
      p.entries.push(e);
      if (e.side === 'left') p.leftQty += e.item.quantity;
      else if (e.side === 'right') p.rightQty += e.item.quantity;
    });

    if (products.length === 1) {
      products[0].options = group.options;
      return products;
    }

    const shares = shareGiftsByProduct(group.totalGiftQty, products, group.rule);
    products.forEach((p, i) => {
      const lEn = p.leftQty > 0, rEn = p.rightQty > 0;
      let options = shares[i] > 0 ? buildOptions(shares[i], lEn, rEn, p.leftQty, p.rightQty, group.rule) : [];
      // A product that only qualifies together with the others has no rule share per eye;
      // then each eye can take free boxes up to the boxes bought for it.
      if (shares[i] > 0 && options.length === 0) options = buildOptions(shares[i], lEn, rEn, p.leftQty, p.rightQty, OWN_BOXES_RULE);
      p.options = options;
    });
    return products.filter(p => p.options.length > 0);
  }

  /* Each product's own share of the campaign's free boxes: what its own quantity earns under
     the rule, plus any boxes only earned by pooling (handed out one at a time, products with
     the most boxes not yet counted towards a full "buy" step first). */
  function shareGiftsByProduct(total, products, rule) {
    const buyQty = Number(rule && rule.buyQty) || 1;
    const shares = products.map(p => giftQtyForRule(rule, p.leftQty + p.rightQty));
    let assigned = shares.reduce((a, b) => a + b, 0);

    const order = products.map((p, i) => i)
      .sort((a, b) => ((products[b].leftQty + products[b].rightQty) % buyQty) - ((products[a].leftQty + products[a].rightQty) % buyQty));
    while (assigned < total) {
      for (const i of order) {
        if (assigned >= total) break;
        shares[i]++;
        assigned++;
      }
    }
    // Non-multiple rules can count a reward per product that the campaign only gives once.
    for (let i = shares.length - 1; assigned > total && i >= 0; i--) {
      const cut = Math.min(shares[i], assigned - total);
      shares[i] -= cut;
      assigned -= cut;
    }
    return shares;
  }

  /* Free boxes a quantity earns under one rule — same calculation as the app (calculateGetQuantity). */
  function giftQtyForRule(rule, qty) {
    const buyQty = Number(rule && rule.buyQty);
    const getQty = Number(rule && rule.getQty);
    if (!buyQty || !getQty || !qty) return 0;
    let count = 0;
    if (rule.operator === 'equal') count = rule.isMultiple ? Math.floor(qty / buyQty) : (qty === buyQty ? 1 : 0);
    else if (rule.operator === 'greater_than') count = qty > buyQty ? (rule.isMultiple ? Math.floor(qty / buyQty) : 1) : 0;
    else if (rule.operator === 'greater_than_or_equal') count = qty >= buyQty ? (rule.isMultiple ? Math.floor(qty / buyQty) : 1) : 0;
    return count * getQty;
  }

  /* Spread a group's chosen split over its own products, per eye: each product line gets up
     to what its own quantity earns under the group's rule; anything left over (when products
     only qualify together) goes to the first product on that eye. */
  function allocateGifts(group, choice) {
    const out = [];
    [['left', choice.leftGiftQty], ['right', choice.rightGiftQty]].forEach(([side, qty]) => {
      const sideEntries = group.entries.filter(e => e.side === side);
      if (!sideEntries.length || qty <= 0) return;
      let remaining = qty;
      sideEntries.forEach(e => {
        if (remaining <= 0) return;
        const n = Math.min(remaining, maxGiftForEye(e.item.quantity, group.rule));
        if (n > 0) {
          out.push({ item: e.item, side: side, qty: n });
          remaining -= n;
        }
      });
      if (remaining > 0) {
        const first = out.find(a => a.side === side && a.item === sideEntries[0].item);
        if (first) first.qty += remaining;
        else out.push({ item: sideEntries[0].item, side: side, qty: remaining });
      }
    });
    return out;
  }

  /* Comparable key for "which parent variant gets how many free boxes on which eye". */
  function giftAllocationKey(rows) {
    const totals = {};
    rows.forEach(r => {
      const k = r.variantId + '|' + r.side;
      totals[k] = (totals[k] || 0) + r.qty;
    });
    return Object.keys(totals).sort().map(k => k + ':' + totals[k]).join(',');
  }

  async function executeGiftUpdate(plans, shouldReload = true) {
    const cart = await fetch(window.Shopify.routes.root + 'cart.js').then(r => r.json());
    const currentGifts = (cart.items || []).filter(i => {
      if (!isGiftItem(i)) return false;
      return i.final_price < i.original_price || i.final_price === 0 || i.price === 0 || i.total_discount > 0 || (i.discounts && i.discounts.length > 0);
    });

    if (currentGifts.length > 0) {
      await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: currentGifts.reduce((acc, g) => ({ ...acc, [g.key]: 0 }), {}) })
      });
    }

    // Build each gift ALWAYS from the main product it belongs to, so the gift variant, its eye
    // side (and its Box / prescription display props) are guaranteed correct — never
    // inherited from a possibly mis-sided existing gift line, and never taken from a product
    // of another campaign. Both eyes can share one gift variant, so the side is defined by
    // the props we stamp, not by the variant id.
    const createFromMain = (mainProd, side, qty) => {
      const gId = getGiftVariantId(mainProd);
      if (!gId) return null;

      // Copy the main item's display properties (Box, prescription, …), then stamp the
      // gift-specific ones on top.
      const props = {};
      for (let k in mainProd.properties) {
        if (k !== '_tired_free') props[k] = mainProd.properties[k];
      }
      props['_Eye Side'] = side === 'left' ? 'Left Eye (OS)' : 'Right Eye (OD)';
      props['_side'] = side;
      props['_tired_free'] = JSON.stringify({ status: true, parent_id: mainProd.variant_id, qty: qty });

      return { id: parseInt(gId), quantity: qty, properties: props };
    };

    const toAdd = [];
    plans.forEach(plan => {
      allocateGifts(plan.group, plan.choice).forEach(a => {
        const line = createFromMain(a.item, a.side, a.qty);
        if (line) toAdd.push(line);
      });
    });

    if (toAdd.length > 0) {
      await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: toAdd })
      });
    }

    if (shouldReload) window.location.reload();
  }

 /* Max free boxes for one eye, from the campaign rule the API returned (e.g. buy 4 get 2 → half,
    buy 1 get 1 → all). Falls back to half when no rule is available. */
 function maxGiftForEye(eyeQty, rule) {
  var buyQty = Number(rule && rule.buyQty);
  var getQty = Number(rule && rule.getQty);
  if (!buyQty || !getQty) return Math.floor(eyeQty / 2);
  return Math.floor(eyeQty * getQty / buyQty);
 }

 function buildOptions(total, lEn, rEn, lQ, rQ, rule) {
  let res = [];
  let maxLeftGift = maxGiftForEye(lQ, rule);
  let maxRightGift = maxGiftForEye(rQ, rule);

  for (let l = 0; l <= total; l++) {
    let r = total - l;
    if (l === 0 && r === 0) continue;

    if (l > maxLeftGift) continue;
    if (r > maxRightGift) continue;

    res.push({ leftGiftQty: l, rightGiftQty: r });
  }
  return res.length ? res : [];
}


  function initSignature() {
    const tryInit = () => {
      const map = window.__giftVariantMap || window.variantMetafields || {};
      if (Object.keys(map).length > 0) {
        syncGiftsInCart(false);
      } else {
        setTimeout(tryInit, 500);
      }
    };
    tryInit();
  }

  function init() {
    initSignature();
    const orgFetch = window.fetch;
    window.fetch = function () {
      return orgFetch.apply(this, arguments).then(res => {
        const url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0].url || '');
        if (!syncInProgress && url && (url.includes('/cart/change') || url.includes('/cart/update'))) {
          clearTimeout(debounceTimer);
          // Run the gift sync right after the cart change/update request completes. A small
          // debounce still coalesces rapid clicks (e.g. tapping +/- several times) without
          // the long lag the previous value introduced.
          debounceTimer = setTimeout(() => syncGiftsInCart(true), 300);
        }
        return res;
      });
    };
  }
  init();
})();
